import { type MenuItemType } from "@/types";

export const menuItems: MenuItemType[] = [
  {
    icon: "dashboard",
    slug: "main",
    label: "",
    isTitle: true,
    children: [
      {
        url: "/",
        slug: "pages:Overview",
        label: "Overview",
        icon: "dashboard",
      },
      {
        url: "/schedule",
        slug: "pages:pages-empty",
        label: "Schedule",
        icon: "akar-icons:calendar",
      },
      {
        url: "/programmesbroadcasts",
        slug: "pages:pages-empty",
        label: "Programmes & broadcasts",
        icon: "streamline-sharp:slide-show-play",
      },
      {
        url: "/attendancecredits",
        slug: "pages:pages-empty",
        label: "Attendance & credits",
        icon: "bi:list-check",
      },
      {
        url: "/members",
        slug: "pages:pages-empty",
        label: "Members",
        icon: "clarity:users-line",
      },
      {
        url: "/profile",
        slug: "pages:pages-empty",
        label: "Profile",
        icon: "settings",
      },
    ],
  },
];
